import { Inject, Injectable, DOCUMENT } from '@angular/core';
import { EventSummary, LiveFieldEvent, MeetList, TeamList } from '@athleticnet/athletic-live-api-models';
import { BehaviorSubject, catchError, combineLatest, map, Observable, of, Subscription } from 'rxjs';
import { MeetEventSummary } from '@athleticnet/athletic-live-api-models/lib/models/firebase/meet-event-summary.interface';
import { EventFilterModel } from '../models/event-filter.model';
import { LiveRunEvent } from '@athleticnet/athletic-live-api-models/lib/models/firebase/live-run-event.model';
import { BreakpointObserver } from '@angular/cdk/layout';
import { environment } from '../../../environments/environment';

import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class IsDarkModeService {
  darkMode = true;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private localStorageService: LocalStorageService,
  ) {}

  private _isDarkMode: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public readonly isDarkMode: Observable<boolean> = this._isDarkMode.asObservable();

  toggleDarkMode() {
    if (this.darkMode) {
      this.localStorageService.setDisplayModeModePreference(false);
      this.setLightMode();
    } else {
      this.localStorageService.setDisplayModeModePreference(true);
      this.setDarkMode();
    }
  }

  setLightMode() {
    this.darkMode = false;
    const darkModeAttr = this.document.getElementById('body')?.attributes.getNamedItem('data-bs-theme');
    if (darkModeAttr) {
      this.document.getElementById('body')?.attributes.removeNamedItem('data-bs-theme');
    }
    this._isDarkMode.next(this.darkMode);
  }

  setDarkMode() {
    this.darkMode = true;
    const attr = this.document.createAttribute('data-bs-theme');
    attr.value = 'dark';
    this.document.getElementById('body')?.attributes.setNamedItem(attr);
    this._isDarkMode.next(this.darkMode);
  }
}
